import { b as n, a as t } from "./addMonths-Ca2KMx6g.mjs";
function r(s, a) {
  return n(s, -a);
}
function u(s, a) {
  return t(s, -a);
}
export {
  r as a,
  u as s
};
